import React, { useState, useEffect } from 'react';
import { parseProps, componentIdGenerator } from './@uteis';
import BRList from '../../assets/dsgov/js/components/list';
import '../../assets/dsgov/css/components/list.css';

const List = (_props) => {
  const [componentId] = useState(
    `list${componentIdGenerator()}`,
  );
  const props = parseProps(_props);

  useEffect(() => {
    if (props.collapsible) {
      new BRList(
        'br-list-collapsible',
        window.document.querySelector(`.${componentId}`),
      );
    }
    if (props.checkable) {
      new BRList(
        'br-list-checkable',
        window.document.querySelector(`.${componentId}`),
      );
    }
    if (!props.checkable && !props.collapsible) {
      new BRList(
        'br-list',
        window.document.querySelector(`.${componentId}`),
      );
    }
  });

  let classes = `${componentId} br-list `;
  if (props.classes) {
    classes += props.classes;
  }

  const attr = {
    collapsible: props.collapsible,
    unique: props.unique,
    'three-lines': props['three-lines'],
    'two-lines': props['two-lines'],
    style: props.style,
  };

  return (
    <div className={classes} {...attr}>
      { 'header' in props
        ? (
          <div className="header">
            {props.header}
          </div>
        )
        : null}
      {props.children}
    </div>
  );
};

export default List;
